module.exports = __webpack_public_path__ + "img/man_about.bf3d392c.png";